import React from 'react';
import Icon from 'components/AppIcon';

const SolutionSlide = () => {
  const clientFeatures = [
    {
      icon: 'Search',
      title: 'Smart Lawyer Matching',
      description: 'AI-powered matching based on expertise, location, and case type'
    },
    {
      icon: 'MessageSquare',
      title: 'Secure Communication',
      description: 'Encrypted messaging and video consultations'
    },
    {
      icon: 'Eye',
      title: 'Case Progress Tracking',
      description: 'Real-time updates on case status and milestones'
    },
    {
      icon: 'FileText',
      title: 'Document Access Portal',
      description: 'Secure access to case documents and legal papers'
    }
  ];

  const lawyerFeatures = [
    {
      icon: 'Briefcase',
      title: 'Complete Case Management',
      description: 'Track cases, deadlines, and court appearances'
    },
    {
      icon: 'Users',
      title: 'Client Relationship Management',
      description: 'Manage client information and communication history'
    },
    {
      icon: 'Folder',
      title: 'Document Management',
      description: 'Version control, sharing, and secure storage'
    },
    {
      icon: 'Video',
      title: 'Video Consultations',
      description: 'Conduct secure online meetings with clients'
    },
    {
      icon: 'BarChart3',
      title: 'Financial Tracking',
      description: 'Invoice management and revenue analytics'
    },
    {
      icon: 'Calendar',
      title: 'Scheduling & Reminders',
      description: 'Automated scheduling and deadline notifications'
    }
  ];

  return (
    <div className="py-12">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-heading font-bold text-text-primary mb-4">
            Our Comprehensive Solution
          </h1>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            A unified platform that connects clients with lawyers and provides complete practice management tools
          </p>
        </div>

        {/* Solution Overview */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
          {/* Client Side */}
          <div className="bg-primary-50 rounded-lg p-8">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="User" size={24} color="white" />
              </div>
              <h2 className="text-2xl font-heading font-bold text-text-primary">For Clients</h2>
            </div>
            
            <div className="space-y-4">
              {clientFeatures?.map((feature, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <Icon name={feature?.icon} size={16} className="text-primary" />
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-text-primary mb-1">
                      {feature?.title}
                    </h3>
                    <p className="text-sm text-text-secondary">
                      {feature?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Lawyer Side */}
          <div className="bg-secondary-50 rounded-lg p-8">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-secondary-600 rounded-lg flex items-center justify-center">
                <Icon name="Scale" size={24} color="white" />
              </div>
              <h2 className="text-2xl font-heading font-bold text-text-primary">For Lawyers</h2>
            </div>
            
            <div className="space-y-4">
              {lawyerFeatures?.map((feature, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-secondary-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <Icon name={feature?.icon} size={16} className="text-secondary-600" />
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-text-primary mb-1">
                      {feature?.title}
                    </h3>
                    <p className="text-sm text-text-secondary">
                      {feature?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Key Differentiators */}
        <div className="bg-gradient-to-r from-primary to-secondary-600 rounded-lg p-8 text-white">
          <h2 className="text-2xl font-heading font-bold mb-6 text-center">What Makes Us Different</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <Icon name="Globe" size={32} color="white" />
              </div>
              <h3 className="font-heading font-semibold mb-2">Kenya-Specific</h3>
              <p className="text-white/90 text-sm">Built for Kenyan legal system and regulations</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <Icon name="Smartphone" size={32} color="white" />
              </div>
              <h3 className="font-heading font-semibold mb-2">Mobile-First</h3>
              <p className="text-white/90 text-sm">Designed for Kenya's mobile-first population</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <Icon name="CreditCard" size={32} color="white" />
              </div>
              <h3 className="font-heading font-semibold mb-2">Local Payments</h3>
              <p className="text-white/90 text-sm">Integrated with M-Pesa and local payment methods</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionSlide;